import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  Users,
  Download,
  Plus,
  Archive,
  ArrowRightLeft,
} from 'lucide-react';


import { Button } from "../../../components/ui/button";

export default function LeadsHeader({
  onShowImport,
  onShowForm,
  onShowArchives,
  selectedLeads = [],
  onTransformer,
  onArchiver
}) {
  return (
    <div
      className="
        relative z-20
        flex shrink-0 flex-col
        gap-6
        overflow-visible
        workspace-card
        bg-cover bg-center bg-no-repeat
        p-4 sm:p-6
        mb-6
        xl:flex-row xl:items-center xl:justify-between
      "
      style={{
        backgroundImage:
          "url('/assets/backgrounds/lighthouse_bg.png')",
      }}
    >
      {/* Voile sombre utilisant les tokens Hipparchus */}
      <div
        aria-hidden="true"
        className="
          pointer-events-none
          absolute inset-0 z-0
          rounded-[var(--hp-radius-lg)]
          bg-overlay
        "
      />

      {/* Partie gauche : titre et icône */}
      <div
        className="
          relative z-10
          flex min-w-0 shrink-0
          flex-col items-start
          gap-3
          sm:flex-row sm:items-center sm:gap-4
        "
      >
        <div
          className="
            flex h-12 w-12 shrink-0
            items-center justify-center
            rounded-full
            bg-secondary
            text-inverse
            shadow-hp-sm
          "
        >
          <Users className="h-6 w-6" />
        </div>

        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-inverse">
            Gestion des leads
          </h1>

          <p className="mt-1 text-sm text-inverse opacity-80">
            Gérez vos contacts et qualifiez-les en prospects.
          </p>
        </div>
      </div>

      {/* Partie droite : actions */}
      <div
        className="
          relative z-50
          flex w-full min-w-0
          flex-col gap-3
          xl:w-auto xl:flex-row xl:items-center
        "
      >
        {/* Boutons */}
        <div
          className="
            relative z-[60]
            flex flex-wrap items-center
            gap-3
          "
        >
          <AnimatePresence mode="popLayout">
            {selectedLeads.length > 0 ? (
              <motion.div
                key="actions-multi"
                layout
                initial={{ opacity: 0, filter: "blur(4px)", y: -5 }}
                animate={{ opacity: 1, filter: "blur(0px)", y: 0 }}
                exit={{ opacity: 0, filter: "blur(4px)", y: 5 }}
                transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
                className="flex items-center gap-3"
              >
                <Button
                  variant="accent"
                  onClick={onTransformer}
                >
                  <ArrowRightLeft className="h-4 w-4 mr-2" />
                  Transformer ({selectedLeads.length})
                </Button>
                <Button
                  variant="destructive"
                  onClick={onArchiver}
                >
                  <Archive className="h-4 w-4 mr-2" />
                  Archiver
                </Button>
              </motion.div>
            ) : (
              <motion.div
                key="actions-single"
                layout
                initial={{ opacity: 0, filter: "blur(4px)", y: -5 }}
                animate={{ opacity: 1, filter: "blur(0px)", y: 0 }}
                exit={{ opacity: 0, filter: "blur(4px)", y: 5 }}
                transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
                className="flex items-center gap-3"
              >
                <Button
                  variant="secondary"
                  onClick={onShowImport}
                >
                  <Download className="h-4 w-4 mr-2" />
                  Importer
                </Button>

                <Button
                  variant="accent"
                  onClick={onShowForm}
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Ajouter
                </Button>
              </motion.div>
            )}
          </AnimatePresence>

          <div
            aria-hidden="true"
            className="
              mx-1 hidden h-8
              border-l border-workspace
              sm:block
            "
          />

          <Button
            variant="secondary"
            onClick={onShowArchives}
          >
            <Archive className="h-4 w-4 mr-2" />
            Archives
          </Button>
        </div>
      </div>
    </div>
  );
}